module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "vue-newsletter-signup"
    }
  }, [_c('div', {
    staticClass: "row expanded newsletter bg-dgrey img-txt-pnls",
    attrs: {
      "data-equalizer": ""
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "small-12 large-6 large-pull-6 columns pddxy-50 txt",
    attrs: {
      "data-equalizer-watch": ""
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row small-collapse medium-uncollapse wwf-form dark"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns ng-invalid"
  }, [_c('span', {
    staticClass: "input-border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "placeholder": "First name",
      "type": "text",
      "data-vv-as": "First name",
      "id": "target-newsletter"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "alert-box-c"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstName')),
      expression: "errors.has('firstName')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('firstName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns ng-invalid"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "placeholder": "Last name",
      "type": "text",
      "data-vv-as": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-box-c"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastName')),
      expression: "errors.has('lastName')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('lastName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns ng-invalid"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true,
        newsletterCheckEmail: true
      }),
      expression: "{required: true, email: true, newsletterCheckEmail: true}"
    }],
    class: {
      'border-red': _vm.errors.has('email') || _vm.errors.has('newsletterCheckEmail')
    },
    attrs: {
      "name": "email",
      "placeholder": "Email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3915/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "alert-box-c"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns ng-invalid"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "text",
      "data-vv-as": "Postcode"
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-box-c"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('postCode')),
      expression: "errors.has('postCode')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('postCode')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns"
  }, [_c('a', {
    staticClass: "bttn-lrg-arrw",
    on: {
      "click": _vm.postForm
    }
  }, [_vm._v("SIGNUP")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 large-6 large-push-6 columns credit-c img",
    attrs: {
      "data-equalizer-watch": ""
    }
  }, [_c('span', {
    staticClass: "span-image"
  }), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_vm._v("© Troy Mayne")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row small-collapse medium-uncollapse white-text"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('h2', [_vm._v("Get updates")]), _vm._v(" "), _c('p', {
    staticClass: "get-updates"
  }, [_vm._v("Sign up and we’ll keep you up-to-date with the latest news on WWF’s work to protect endangered wildlife and habitats and how you can help make a real difference to their future.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae13deb4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=tqk19250jg!./~/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./src/components/NewsletterSignup.vue
// module id = 723
// module chunks = 0